import * as React from "react";
const SvgConnect20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 10,
        fill: "black",
        viewBox: "0 0 21 10"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6.086 4H.5v2h5.586L3.793 8.293l1.414 1.414L9.914 5 5.207.293 3.793 1.707 6.086 4Zm8.828 2H20.5V4h-5.586l2.293-2.293L15.793.293 11.086 5l4.707 4.707 1.414-1.414L14.914 6Z",
      clipRule: "evenodd"
    })
  );
export default SvgConnect20Px;
